import moment from 'moment'
import React, { createContext, useContext, useState } from 'react'

import { localStorageInstance } from '@/modules/localStorage'
import { OccurrenceTypes } from '@/modules/occurrences/domain/models/OccurrenceTypes'
import { useQueryStateContext } from '@/ui/contexts/QueryStateContext'

const OccurrencesContext = createContext<{
  filter: {
    date: string
    personaName?: string | undefined
    pendingActivities: boolean
    statusOccurrences?: OccurrenceTypes | undefined
    floor?: string | undefined
  }
  settings: {
    reloadScreen: boolean
  }
  setDate: React.Dispatch<React.SetStateAction<string>>
  setPendingActivities: React.Dispatch<React.SetStateAction<boolean>>
  setStatusOccurrences: React.Dispatch<
    React.SetStateAction<OccurrenceTypes | undefined>
  >
  setFloor: React.Dispatch<React.SetStateAction<string | undefined>>
  setReloadScreen: React.Dispatch<React.SetStateAction<boolean>>
  setPersonaName: React.Dispatch<React.SetStateAction<string>>
}>({
  filter: {
    date: '',
    personaName: undefined,
    statusOccurrences: undefined,
    floor: undefined,
    pendingActivities: false
  },
  settings: {
    reloadScreen: false
  },
  setDate: () => {},
  setStatusOccurrences: () => {},
  setReloadScreen: () => {},
  setPendingActivities: () => {},
  setFloor: () => {},
  setPersonaName: () => {}
})

export const useOccurrencesContext = () => useContext(OccurrencesContext)

export default function OccurrencesProvider({
  children
}: {
  children: React.ReactNode
}) {
  const [searchParams] = useQueryStateContext()

  const persistentFilters = localStorageInstance.getOccurrencesFilter()
  const filter = {
    personaName: searchParams.get('personaName') ?? '',
    date: searchParams.get('date'),
    statusOccurrences:
      (searchParams.get('status') as OccurrenceTypes | null) ?? undefined,

    pendingActivities:
      searchParams.get('pendingActivities') === 'true' ||
      persistentFilters?.pendingActivities,
    reloadScreen: persistentFilters?.reloadScreen,
    floor: searchParams.get('floor') ?? persistentFilters?.floor
  }
  const [date, setDate] = useState(
    moment(filter.date ?? undefined).format(moment.HTML5_FMT.DATE)
  )

  const [personaName, setPersonaName] = useState<string>(filter.personaName)
  // const [rawPersonaName, setRawPersonaName] = useState<string>(
  //   filter.personaName
  // )
  // const [debouncedPersonaName] = useDebounceValue(
  //   rawPersonaName,
  //   DEBOUNCE_DELAY
  // )

  const [statusOccurrences, setStatusOccurrences] = useState<
    OccurrenceTypes | undefined
  >(filter.statusOccurrences ?? undefined)

  const [reloadScreen, setReloadScreen] = useState<boolean>(
    filter.reloadScreen ?? false
  )
  const [pendingActivities, setPendingActivities] = useState<boolean>(
    filter.pendingActivities ?? false
  )
  const [floor, setFloor] = useState<string | undefined>(
    filter.floor ?? undefined
  )

  return (
    <OccurrencesContext.Provider
      value={{
        filter: {
          date,
          personaName,
          statusOccurrences,
          floor,
          pendingActivities
        },
        settings: {
          reloadScreen
        },
        setDate,
        setStatusOccurrences,
        setReloadScreen,
        setPendingActivities,
        setFloor,
        setPersonaName
      }}
    >
      {children}
    </OccurrencesContext.Provider>
  )
}
